module.exports = __webpack_public_path__ + "static/media/Coach_image.9dff34d4.jpg";